import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react"
import { FunctionComponent, PropsWithChildren, RefObject } from "react"

import { classNames } from "lib/classNames"

/**
 * @deprecated Use the ModalProps type instead.
 */
export interface DeprecatedModalProps {
  open: boolean
  onClose: () => void
  size?: "sm" | "md" | "lg"
  topPaddingOnly?: boolean
  lessRoundedBorders?: boolean
  className?: string
  blurBackground?: boolean
  initialFocus?: RefObject<HTMLElement | null>
  scrollable?: boolean
}

/**
 * @deprecated Use the Modal component instead.
 */
export const DeprecatedModal: FunctionComponent<
  PropsWithChildren<DeprecatedModalProps>
> = (props) => {
  const {
    open,
    onClose,
    initialFocus,
    blurBackground,
    children,
    size = "sm",
    lessRoundedBorders,
    topPaddingOnly,
    scrollable = true,
    className,
  } = props

  return (
    <Dialog
      open={open}
      onClose={onClose}
      initialFocus={initialFocus}
      className={classNames("z-50", className)}
    >
      <DialogBackdrop
        className={classNames(
          "dark:bg-gray-1000/75 fixed inset-0 z-50 bg-gray-500/75",
          blurBackground && "backdrop-blur-xs"
        )}
        aria-hidden="true"
      />
      <div
        className={
          "fixed inset-0 z-50 flex w-full items-center justify-center p-4"
        }
      >
        <DialogPanel
          className={classNames(
            "rounded-overlay max-h-full w-full bg-white p-6 shadow-xl dark:bg-gray-800",
            scrollable && "overflow-y-auto",
            size === "sm" && "max-w-160",
            size === "md" && "max-w-200",
            size === "lg" && "max-w-250",
            lessRoundedBorders && "rounded-sm",
            topPaddingOnly && "p-0 pt-6"
          )}
        >
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
